import { render, staticRenderFns } from "./villageSituation.vue?vue&type=template&id=26607c58&scoped=true&"
import script from "./villageSituation.vue?vue&type=script&lang=js&"
export * from "./villageSituation.vue?vue&type=script&lang=js&"
import style0 from "./villageSituation.vue?vue&type=style&index=0&id=26607c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26607c58",
  null
  
)

export default component.exports